import React, { useEffect, useState, useRef } from 'react';
import { Spin, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { type AppDispatch, type RootState } from '../../../redux/store';
// import {
//   getUnapprovedPaymentsAction,
//   updateUnsettledPaymentsAction,
// } from '../../Loan/store/loanActions';
import {
  getUnapprovedPledgePaymentAction,
  updatePledgePaymentAction,
} from '../../Pledge/store/pledgeActions';
import { type PledgePayment } from '../../Pledge/store/pledgeTypes';

export default function PledgeApproval(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();

  const { unapprovedPledgePayments }: any = useSelector<RootState>(
    (rootState) => rootState.pledge
  );

  const processingRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const getUnapprovalList = async (): Promise<void> => {
    setIsLoading(true);

    await getUnapprovedPledgePaymentAction(dispatch, {});
    processingRef.current = false;
    setIsLoading(false);
  };

  useEffect(() => {
    void getUnapprovalList();
  }, []);

  const handleUpdate = async (pledgePayment: PledgePayment, status: string) => {
    // if (processingRef.current) return;
    // processingRef.current = true;
    await updatePledgePaymentAction(dispatch, {
      id: pledgePayment._id ?? '',
      status,
    });
    void getUnapprovalList();
    processingRef.current = false;
  };

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      render: (_: unknown, record: PledgePayment, index: number) => index + 1,
      width: 50,
    },
    {
      title: 'Branch',
      dataIndex: 'branch',
      key: 'branch',
      width: 150,
      render: (_: unknown, record: PledgePayment, index: number) => (
        <p>{record.branch?.name}</p>
      ),
    },
    {
      title: 'Pledge Number',
      dataIndex: 'pledgeNumber',
      key: 'pledgeNumber',
      render: (_: unknown, record: PledgePayment, index: number) => (
        <p>{record.pledgeNumber}</p>
      ),
    },
    {
      title: 'Principal',
      dataIndex: 'principal',
      key: 'principal',
      render: (_: unknown, record: PledgePayment, index: number) => (
        <p>{record.principal}</p>
      ),
    },
    {
      title: 'Interest Amount',
      dataIndex: 'interestAmount',
      key: 'interestAmount',
      render: (_: unknown, record: PledgePayment, index: number) => (
        <p>{record.interestAmount}</p>
      ),
    },
    {
      title: 'Reducing Field',
      dataIndex: 'reducingField',
      key: 'reducingField',
      render: (_: unknown, record: PledgePayment, index: number) => (
        <p>{record.reducingField}</p>
      ),
    },
    {
      title: 'Extra',
      dataIndex: 'extra',
      key: 'extra',
      render: (_: unknown, record: PledgePayment, index: number) => (
        <p>{record.extra}</p>
      ),
    },
    {
      title: 'Accept',
      dataIndex: 'actions',
      width: 100,
      render: (_: unknown, record: PledgePayment, index: number) => (
        <button
          className="search__button"
          style={{
            background: !processingRef.current ? '#27ae60' : '#b2b2b2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 24px',
            fontWeight: 700,
            cursor: !processingRef.current ? 'pointer' : 'not-allowed',
            opacity: !processingRef.current ? 1 : 0.7,
          }}
          disabled={processingRef.current}
          onClick={() => {
            if (!processingRef.current) {
              processingRef.current = true;
              void handleUpdate(record, 'cash_settlement');
            }
          }}
        >
          Accept
        </button>
      ),
    },
    {
      title: 'Reject',
      dataIndex: 'actions2',
      width: 100,
      render: (_: unknown, record: PledgePayment, index: number) => (
        <button
          className="search__button"
          style={{
            background: !processingRef.current ? '#e74c3c' : '#b2b2b2',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 24px',
            fontWeight: 700,
            cursor: !processingRef.current ? 'pointer' : 'not-allowed',
            opacity: !processingRef.current ? 1 : 0.7,
          }}
          disabled={processingRef.current}
          onClick={() => {
            if (!processingRef.current) {
              processingRef.current = true;
              void handleUpdate(record, 'rejected');
            }
          }}
        >
          Reject
        </button>
      ),
    },
  ];

  return (
    <div className="users__table__page">
      {!(unapprovedPledgePayments.length > 0) && (
        <Spin spinning={isLoading} fullscreen />
      )}
      <div style={{ width: '100%' }}>
        <Table dataSource={unapprovedPledgePayments} columns={columns} />
      </div>
    </div>
  );
}
